import { css } from "@emotion/react";
import { kitText } from "../../styles";

export const styles = {
  wrapper: css`
    --tag-padding: var(--spacing-4);
    padding: var(--tag-padding) calc(var(--tag-padding) * 2);
    color: var(--tag-color);
    background-color: color(from var(--tag-color) srgb r g b / 0.15);
    border-radius: var(--font-size-body);
    ${kitText.variant.body}
    ${kitText.style.bold}

    /* Override <Icon> wrapper styles so that the svg is inline with text */
    span {
      display: inline-block;
      margin-right: var(--tag-padding);

      div {
        display: inline-block;
      }
    }

    /** 
     * This extra vertical alignment is only needed because the icon size and text
     * line-heights are out of sync. We can remove this if we reconcile those styles.
     */
    svg {
      vertical-align: middle;
      transform: translateY(-1px);
    }
  `,
  small: css`
    ${kitText.variant.micro}
  `
};
